import { DiscoveryV2ListParameterModifierType } from "@sellar-io/api-v2/types";

export const packagedPriceFilterType = {
  lessThan10: {
    name: "Up to £10",
    query: { type: "price", modifier: "LESS_THAN", value: 1000 },
  },
  lessThan20: {
    name: "£10 - £20",
    query: {
      type: "price",
      modifier: "BETWEEN",
      value: { low: 1000, high: 2000 },
    },
  },
  between20And30: {
    name: "£20 - £30",
    query: {
      type: "price",
      modifier: "BETWEEN",
      value: { low: 2000, high: 3000 },
    },
  },
  between30And40: {
    name: "£30 - £40",
    query: {
      type: "price",
      modifier: "BETWEEN",
      value: { low: 3000, high: 4000 },
    },
  },
  between40And50: {
    name: "£40 - £50",
    query: {
      type: "price",
      modifier: "BETWEEN",
      value: { low: 4000, high: 5000 },
    },
  },
  between50And60: {
    name: "£50 - £60",
    query: {
      type: "price",
      modifier: "BETWEEN",
      value: { low: 5000, high: 6000 },
    },
  },
  between60And70: {
    name: "£60 - £70",
    query: {
      type: "price",
      modifier: "BETWEEN",
      value: { low: 6000, high: 7000 },
    },
  },
  between70And80: {
    name: "£70 - £80",
    query: {
      type: "price",
      modifier: "BETWEEN",
      value: { low: 7000, high: 8000 },
    },
  },
  between80And100: {
    name: "£80 - £100",
    query: {
      type: "price",
      modifier: "BETWEEN",
      value: { low: 8000, high: 10000 },
    },
  },
  over100: {
    name: "Over £100",
    query: { type: "price", modifier: "GREATER_THAN_OR_EQUAL", value: 10000 },
  },
} as const satisfies Record<
  string,
  {
    name: string;
    query: Extract<DiscoveryV2ListParameterModifierType, { type: "price" }>;
  }
>;

export const draughtPriceFilterType = {
  lessThan40: {
    name: "Up to £40",
    query: { type: "price", modifier: "LESS_THAN", value: 4000 },
  },
  between40And60: {
    name: "£40 - £60",
    query: {
      type: "price",
      modifier: "BETWEEN",
      value: { low: 4000, high: 6000 },
    },
  },
  between60And80: {
    name: "£60 - £80",
    query: {
      type: "price",
      modifier: "BETWEEN",
      value: { low: 6000, high: 8000 },
    },
  },
  between80And100: {
    name: "£80 - £100",
    query: {
      type: "price",
      modifier: "BETWEEN",
      value: { low: 8000, high: 10000 },
    },
  },
  between100And120: {
    name: "£100 - £120",
    query: {
      type: "price",
      modifier: "BETWEEN",
      value: { low: 10000, high: 12000 },
    },
  },
  between120And140: {
    name: "£120 - £140",
    query: {
      type: "price",
      modifier: "BETWEEN",
      value: { low: 12000, high: 14000 },
    },
  },
  between140And160: {
    name: "£140 - £160",
    query: {
      type: "price",
      modifier: "BETWEEN",
      value: { low: 14000, high: 16000 },
    },
  },
  between160And180: {
    name: "£160 - £180",
    query: {
      type: "price",
      modifier: "BETWEEN",
      value: { low: 16000, high: 18000 },
    },
  },
  over180: {
    name: "Over £180",
    query: { type: "price", modifier: "GREATER_THAN_OR_EQUAL", value: 18000 },
  },
} as const satisfies Record<
  string,
  {
    name: string;
    query: Extract<DiscoveryV2ListParameterModifierType, { type: "price" }>;
  }
>;

export const priceFilterType = {
  ...packagedPriceFilterType,
  ...draughtPriceFilterType,
};

export type PriceType = keyof (
  | typeof packagedPriceFilterType
  | typeof draughtPriceFilterType
);
